export const Logo = () => {
  return (
    <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.9959 32.4474C15.8478 32.4474 15.675 32.4474 15.5269 32.4474L18.7853 23.4745H23.278C24.0679 23.4745 24.9319 22.8582 25.2034 22.1187L28.7581 12.3817C29.3505 10.7794 28.4125 9.47287 26.7339 9.47287H20.4886L15.2553 23.8689L12.2931 32.0283C5.25791 30.3521 0 24.0415 0 16.4737C0 9.15241 4.93701 2.96507 11.676 1.09162L8.61507 9.49752L3.52996 23.4745H6.91181L11.2317 11.5928H13.7742L9.45436 23.4745H12.8362L16.8846 12.4063C17.477 10.804 16.5637 9.49752 14.8604 9.49752H11.9969L15.28 0.52465C15.5269 0.52465 15.749 0.5 15.9959 0.5C24.8331 0.5 31.9918 7.64872 31.9918 16.4737C31.9918 25.2986 24.8331 32.4474 15.9959 32.4474ZM25.6724 11.5928H23.1299L19.5505 21.3792H22.0931L25.6724 11.5928Z"
        fill="black"
      />
    </svg>
  )
}
